// extracted by mini-css-extract-plugin
export default {"TrustedReviewer":"Vjw1iBUuSPrZSAuvk6ay"};